
import Table from '../../../../components/table';


function AppliedJobsList(props: any) {


  return (
    <div>
      <Table type='appliedJobs' data={props.data} />
    </div>
  )
}


export default AppliedJobsList